import StudyingLessonsApi from '@/api/studying-lessons';

export default {
  namespaced: true,
  state: {
    lessons: [],
  },

  mutations: {
    SET_LESSONS(state, val) {
      state.lessons = val;
    },
  },
  actions: {
    async getLessons({ commit }) {
      try {
        const lessons = await StudyingLessonsApi.getLessons();
        commit('SET_LESSONS', lessons.data);
        return lessons;
      } catch (e) {
        throw e;
      }
    },
    async updateOrCreateLesson ({ commit, dispatch }, data) {
      try {
        const lesson = await StudyingLessonsApi.createOrUpdateLesson(data)
        dispatch('getLessons');
        return lesson
      } catch (e) {
        throw e;
      }
    },
    async deleteLessonRecord({commit, dispatch}, data) {
      try {
        const lessonResponse = await StudyingLessonsApi.removeLesson(data);
        dispatch('getLessons');
        return lessonResponse;
      } catch (e) {
        throw e;
      }
    }
  },

};
